-<template>
  <div>
    <div v-if="!isLocal">
      <div v-if="effectiveUrl!=null">
        <template v-if="type=='image'">

          <template v-if="!isPlaceholder">
            <!--journey view on map-->
            <div>
              <img
                :class="'isMapRoundImg '+journeyBackgroundColor+' journeyOrCollection '+journeyOrCollection+' isJourneyOrderNumber: '+ isJourneyOrderNumber"
                v-if="typeof journeyBackgroundColor!='undefined' &&(effectiveUrl!=null||typeof effectiveUrl!=undefined)&&isMapRoundImg==true"
                :src="effectiveUrl"
                :style="' width: 10vh;height: 10vh;border-radius: 500px;'+this.calcoulateBackgroundColor+';journeyBackgroundColor='+journeyBackgroundColor" />

              <img class="isMapRoundImg"
                v-else-if="(isSelectedStory==true&&isMapRoundImg==true&&isKGimage==true&&effectiveUrl!=null&&typeof effectiveUrl!=undefined)"
                :src="effectiveUrl"
                :style="' width: 120px;height: 120px;border-radius: 500px;'+this.calcoulateBackgroundColor" />

              <img class="isMapRoundImg"
                v-else-if="(isMapRoundImg==true&&isKGimage==true&&effectiveUrl!=null&&typeof effectiveUrl!=undefined)"
                :src="effectiveUrl"
                :style="'width: 80px;height: 80px;border-radius: 50px;'+this.calcoulateBackgroundColor" />
              <v-img cover
                v-else-if="(isMapRoundImg==false&&isKGimage==true&&effectiveUrl!=null&&typeof effectiveUrl!=undefined)"
                :src="effectiveUrl" />
              <!-- cover image preview and -->
              <v-img :cover="isThumbnail!=true ? true : false" :contain="isThumbnail"
                :aspect-ratio="isThumbnail ? 4/3 : ''"
                v-if="(isKGimage!=true&&effectiveUrl&&typeof effectiveUrl!=undefined)" :lazy-src="effectiveUrl"
                :src="effectiveUrl" />


              <div
                v-if="(journeyOrCollection==true&&typeof journeyOrCollection!='undefined'&&typeof isJourneyOrderNumber!='undefined')"
                class="journeyCounterStyle">
                {{isJourneyOrderNumber+1 }}
              </div>
            </div>

          </template>
          <template v-else>
            <v-img :contain="isThumbnail" :aspect-ratio="isThumbnail ? 4/3 : ''"
              :src="require('@/assets/placeholder.png')">
            </v-img>
          </template>
        </template>
        <template v-if="type=='audio'">
          <p class="dont-break-out">{{mediaFileTitle}}</p>
          <audio-player v-if="!isDialogMediaPlayerClosed">
            <source :src="effectiveUrl" />
          </audio-player>
        </template>
        <template v-if="type=='attachment'">
          <a :href="effectiveUrl" download target="_blank">
            <v-icon>mdi-download</v-icon> <span class="dont-break-out"> {{mediaFileTitle}}</span>
          </a>
        </template>
        <template v-if="type=='video'">
          <p class="dont-break-out">{{mediaFileTitle}}</p>
          <video-player v-if="!isDialogMediaPlayerClosed" ref="videoplayer">
            <source :src="effectiveUrl" />
          </video-player>
        </template>
      </div>
    </div>
    <div v-else>
      <template v-if="type=='image'">
      </template>
      <template v-if="type=='audio'">
      </template>
      <template v-if="type=='video'">
      </template>
      <template v-if="type=='attachment'">
      </template>
    </div>
  </div>
</template>

<script>
import {
  audioPlayer
} from 'vue-md-player'

import {
  videoPlayer
} from 'vue-md-player'
import 'vue-md-player/dist/vue-md-player.css'

export default {
  name: 'mediaFileStory',
  data() {
    return {
      cache:{},
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      previewCoverImageUrl:null,
      effectiveUrl: null,
      apiURL: process.env.VUE_APP_ROOT_API,
      dialogvideo: false,
      previewvideourl: ''
      
    }
  },
  watch: {
    mediaUrl(val) {
      this.getMediaFile(val)
    }
  },
  async mounted() {
    this.getMediaFile()
  },
  computed:{
    calcoulateBackgroundColor: {
      
      get: function () {
        if (this.journeyBackgroundColor==1){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney1
        }
        else if (this.journeyBackgroundColor==2){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney2
        }
        else if (this.journeyBackgroundColor==3){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney3
        }
        else  if (this.journeyBackgroundColor==4){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney4
        }
        else if (this.journeyBackgroundColor==5){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney5
        }
        else if (this.journeyBackgroundColor==6){
        return 'border:5px solid '+ this.$vuetify.theme.themes.light.colorPalettejourney6
        }
        else if (typeof this.journeyBackgroundColor=='undefined'){
                  return 'border:2px solid black'

        }
        return 'border:2px solid grey'
      }}

,
    isDialogMediaPlayerClosed:{
            get:function(){
                return this.$store.state.isDialogMediaPlayerClosed
            }
        }
  },
  methods: {
    async getMediaFile() {
      if (!this.isLocal) {
        /*let result = await this.$axios.get(this.apiURL + '/generateMediaUuid', {
          headers: {
            "x-access-token": `Bearer ${this.$store.getters.getAccessToken}`,
            'Content-Type': 'multipart/form-data',
          }
        })*/
        //this.effectiveUrl = "http://localhost:1337/uploads/medium_20200822_132901_83382fb80f.jpg"//this.mediaUrl //+ '&code=' + result.data.code
        
        this.effectiveUrl = this.mediaUrl

      }else{
        this.cache = this.$store.getters.getNewStories
        var array = new Uint8Array(this.cache.imageFile);
        var blobimage = new Blob([array],{type: this.cache.imageType});
      if (blobimage.size!=0){
        this.previewCoverImageUrl = window.URL.createObjectURL(blobimage)
      }else{
        this.previewCoverImageUrl=null
      }
      }
    }
  },
  props: {
    journeyOrCollection:{
      type: Boolean,
      required: false
    },
        isJourneyOrderNumber:{
      type: Number,
      required: false
    },
    isSelectedStory:{
      type: Boolean,
      required: false
    },
    journeyBackgroundColor:{
      type: Number,
      required: false
    },
    isMapRoundImg: {
      type: Boolean,
      required: false
    },
    mediaUrl: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    storyTitle: {
      type: String,
      required: false
    },
    mediaFileTitle: {
      type: String,
      required: false
    },
    isLocal: {
      type: Boolean,
      required: false
    },
    isPlaceholder: {
      type: Boolean,
      required: false
    },
    isKGimage: {
      type: Boolean,
      required: false
    },
    isThumbnail: {
      type: Boolean,
      required: false
    },
  },
  components: {
    videoPlayer,
    audioPlayer
  }
}
</script>
<style>

.journeyCounterStyle {
  font-size: 7vh;
  position: absolute;
  top: 5vh;
  left: 5vh;
  transform: translate(-50%, -50%);
}

.dont-break-out {

  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

}

.isMapRoundImg {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}

.v-image__image {
  background-size: 100% 100%;
}

.imageDashboard {
  width: 100%;
}

.audioicon {
  top: 20vh;
  left: 2vh;
  position: absolute;
}

.videoicon {
  top: 20vh;
  right: 2vh;
  position: absolute;
}

.attachmenticon {
  top: 40vh;
  right: 2vh;
  position: absolute;
}
</style>